import { useEffect, useState } from 'react';
import { useStore } from 'src/contexts/StoreContext';
import { getAddToCartETAInfo, INITIAL_MESSAGE_TIMEOUT } from 'src/helpers/cart.helper';

export const useAddToCartETAInfo = () => {
  const {
    i18n,
    project: { activeProduct },
  } = useStore();

  const [title, setTitle] = useState<string>(i18n.t('modal-upload-to-cart:title'));
  const [description, setDescription] = useState<string>(i18n.t('modal-upload-to-cart:description'));
  const [showInitialMessage, setShowInitialMessage] = useState<boolean>(true);

  useEffect(() => {
    setTimeout(() => {
      setShowInitialMessage(false);
    }, INITIAL_MESSAGE_TIMEOUT);
  }, []);

  useEffect(() => {
    const { title, description } = getAddToCartETAInfo(i18n, {
      eta: activeProduct?.cartEta,
      progress: activeProduct?.progressUploadPercentage,
      networkScore: activeProduct?.networkScore,
      showInitialMessage,
    });

    if (title) {
      setTitle(title);
    }
    if (description) {
      setDescription(description);
    }
  }, [
    showInitialMessage,
    activeProduct?.cartEta,
    activeProduct?.progressUploadPercentage,
    activeProduct?.networkScore,
  ]);

  return { title, description };
};
